import DNBCompanyDetail from './dnb';
import CompanyInfoDetail from './companyinfo';
import CreditSafeDetail from './creditsafe';
import DnbEnterpriseDetail from './dnb-enterprise';

const Drivers = {
    "dun_brad_street": {
        component: (props) => <DNBCompanyDetail {...props} />
    },
    "company_info": {
        component: (props) => <CompanyInfoDetail {...props} />
    },
    "credit_safe": {
        component: (props) => <CreditSafeDetail {...props} />
    },
    "dun_brad_street_enterprise": {
        component: (props) => <DnbEnterpriseDetail {...props} />
    }
}

const DriverHandler = ({ driverKey, ...props }) => {
    const DriverComponent = Drivers[driverKey]?.component;

    if (!DriverComponent) return null;

    return (
        <DriverComponent
            {...props}
        />
    )
}

export default DriverHandler;